export default __webpack_public_path__ + "static/media/user1.28e44cb7.png";